import { componentName, HoneypotClass } from './HoneypotClass';

customElements.define(componentName, HoneypotClass);

export { HoneypotClass, componentName };
